module.exports = __webpack_public_path__ + "/img/30c50037e9bb915efe61a1415a06da26.png";


//////////////////
// WEBPACK FOOTER
// ./assets/logo.png
// module id = 239
// module chunks = 0